import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import apiService from '../services/api.service';
import { t } from "i18next";
import { useDispatch, useSelector } from 'react-redux';
import { setCompanyUser, setCompany } from '../Redux/companyReducer';
import { setUser } from '../Redux/userReducer';
import CompanyHeader from './CompanyHeader';
import CompanyLoginModal from './CompanyLoginModal';
import { Fragment } from 'react';
import CompanyVerificationModal from './CompanyVerificationModal';

function Company() {
    const dispatch = useDispatch()
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const companyUser = useSelector((state) => state.company.companyUser)
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const chainId = urlParams.get("chainid") || 0;
    const lang = urlParams.get("lang") || "en";
    const company = useSelector((state) => state.company.company)
    const [waitingForCode, setWaitingForCode] = useState(false)
    const [currentUser, setCurrentUser] = useState(null)
    const handleShow = () => setShowModal(true);
    const handleClose = () => {
        setShowModal(false)
        setWaitingForCode(false)
        dispatch(setCompany(null))
        dispatch(setCompanyUser(null))
    }

    const checkVerificationCode = (data, setError) => {
        const code = data.code
        setIsLoading(true)
        apiService.confirmCode(currentUser.iD, code)
            .then((response) => {
                if (response.data.data && !response.data.HasErrors) {
                    apiService.getCompany(currentUser.companyId)
                        .then((response) => {
                            dispatch(setCompany(response.data.data[0]))
                        })
                    apiService.getCustomer(currentUser.email)
                        .then((response) => {
                            dispatch(setCompanyUser(response.data.data[0]))
                            const loggedUser = {
                                id: response.data.data[0].customerId,
                                email: response.data.data[0].customerEmail
                            }
                            dispatch(setUser(loggedUser))
                        })
                    setShowModal(false)
                    setWaitingForCode(false)
                    setIsLoading(false)

                } else {
                    setError('code', {message: t("failedVerification")});
                    setIsLoading(false)
                }
            }, (error) => {
                console.log(error)
                setIsLoading(false)
                setError('code', {message: t("failedVerification")});
            })
    }

    const handleLogin = (data = currentUser, setError = null) => {
        setIsLoading(true)
        const user = {
            Email: data.email
        }
        apiService.login(user).then((response) => {
            if (response.data) {
                setWaitingForCode(true)
                setIsLoading(false)
                let sessionUser = response.data.data.user
                sessionUser.email = data.email
                setCurrentUser(sessionUser)
            } else {
                setError('email', { type: 'custom', message: t("customerNotFound") });
                setIsLoading(false)
            }
        }, () => {
            setError('email', { type: 'custom', message: t("customerNotFound") });
            setIsLoading(false)
        })

    };

    return (
        <div className='company-login'>
            {!company && !companyUser && !waitingForCode &&
                <Fragment>
                    <Button className="company-login-btn" aria-label={t("loginForCompaniesAndOrganizations")} variant="light" onClick={handleShow}>{t("loginForCompaniesAndOrganizations")}</Button>
                    <CompanyLoginModal
                        showModal={showModal}
                        isLoading={isLoading}
                        handleLogin={handleLogin}
                        handleClose={handleClose}
                    />
                </Fragment>
            }
            {companyUser && !waitingForCode &&
                <CompanyHeader
                    lang={lang}
                    chainId={chainId}
                    company={company}
                    urlParams={urlParams}
                    isLoading={isLoading}
                    companyUser={companyUser}
                    setIsLoading={setIsLoading}
                />
            }
            {waitingForCode && currentUser &&
                <Fragment>
                    <Button className="company-login-btn" aria-label={t("loginForCompaniesAndOrganizations")} variant="light" onClick={handleShow}>{t("loginForCompaniesAndOrganizations")}</Button>
                    <CompanyVerificationModal
                        showModal={showModal}
                        isLoading={isLoading}
                        handleLogin={handleLogin}
                        currentUser={currentUser}
                        handleClose={handleClose}
                        checkVerificationCode={checkVerificationCode}
                    />
                </Fragment>
            }
        </div>
    );
}

export default Company;
